<template>
    <v-container fluid>   
      <LeftMenu  />     
        <v-layout row wrap>  
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="deliveryListComputed"
              :items-per-page="1000"
              item-key="id"
              sort-by="id"
              :sort-desc=true
              class="elevation-1"
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Deliveries</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <template >
                    <v-layout row wrap>  
                      <v-flex xs2 class="pr-3">
                        <DatePicker picker-label="" :date-value="deliveriesStartDate" @dateSelected="deliveriesStartDate=$event" />
                      </v-flex>
                      <v-flex xs2 class="pr-3"> 
                        <DatePicker picker-label="" :date-value="deliveriesEndDate" @dateSelected="deliveriesEndDate=$event" />                  
                      </v-flex> 
                      <v-flex xs3><v-text-field v-model="search" label="Search " class="mx-4"></v-text-field></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2"  @click="searchDeliveries()">Search</v-btn></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="clearSearch()" >Clear</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="createNewDelivery()" >New Delivery</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                    </v-layout>
                  </template>
                </v-toolbar>
              </template> 
              <template v-slot:body.append>                    
              </template>  
              <template v-slot:footer>       
                <Pagination  :record-count="recordCount" :default-page-size="defaultPageSize"
                       @pageNumberChanged="pageNumberChanged($event)" @pageSizeChanged="pageSizeChanged($event)" />             
              </template> 
              <template v-slot:item.goToDetails="{ item }">              
                <v-icon                  
                  @click="goToDetails(item)">
                  mdi-send
                </v-icon>                
              </template>     
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
              </template>       
              <template v-slot:item.action="{ item }">          
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>                                
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import getCurrentDate from '../../helpers/getCurrentDate';
import getThisYearStart from '../../helpers/getThisYearStart';
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Pagination from '../../components/Pagination';
import formatPrice from '../../helpers/formatter';
const API_URL = 'stock/deliveries';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Pagination
    },
    props: {
      currentCustomer : {}
    },
    data () {
    return {
      search: '',
      deliveriesStartDate: '',
      deliveriesEndDate: '',
      deliveries: [],
      defaultPageSize : 25,
      recordCount : 0,
    }
  },
  computed: {
    headers () {
      return [
        { text: '',align: 'left',sortable: false,value: 'goToDetails'},
        { text: 'Delivery No',  value: 'id'  },  
        { text: 'Delivery Date',  value: 'deliveryDate'  },  
        {
          text: 'Supplier',align: 'left',sortable: true,
          value: 'purchase.supplier.name',
        }, 
        {
          text: 'Purchase No',align: 'left',sortable: true,
          value: 'purchase.id',
        }, 
        { text: 'Status',  value: 'status'  },               
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    deliveryListComputed(){
      return this.deliveries.map((item) => {   
        item.totalPriceFormatted = formatPrice(item.totalPrice);
        return item;    
      })
    },
    formTitle () {
      return  'New Delivery';
    },
  },
  created() {    
    this.fillIntervalDates();
    //this.getDeliveriesByInterval(1,this.defaultPageSize);    
  },
  watch: {
    deliveriesStartDate (val){
      this.deliveriesStartDate = val;
      if(val && this.deliveriesEndDate){        
        this.getDeliveriesByInterval(1,this.defaultPageSize);   
      }
    },
    deliveriesEndDate(val){
      this.deliveriesEndDate = val;
      if(val && this.deliveriesStartDate){      
        this.getDeliveriesByInterval(1,this.defaultPageSize);   
      }
    },
  },
  methods: {
    goToDetails(item){
      this.$router.push('/deliveries/'+item.id);
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.deliveriesStartDate = getThisYearStart();
    },
    async setEndDate(){
      this.deliveriesEndDate = getCurrentDate();
    },
    createNewDelivery(){
      this.$router.push('/deliveries/new');
    },
    clearSearch(){
      this.search = '';
      this.getDeliveriesByInterval(1, this.defaultPageSize);
    },
    getStatusColor (status) {
      if(status == '') return ''
      else if (status =='OPEN') return 'blue'
      else if (status =='SOLD') return 'green'
      else if (status =='EXPIRED') return 'orange'
      else return ''
    },
    deleteItem (item) {
      const index = this.deliveries.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.deliveries.splice(index, 1);
        this.deleteDelivery(item);
      } 
    },
    generatePdf(item) {          
      this.$axios({
        url: this.$apiurl + API_URL+'/'+item.id+'/generatePdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Delivery_'+item.deliveryNo+'.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
    deleteDelivery(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    pageSizeChanged(pageSize){
      this.defaultPageSize = pageSize;
      this.getDeliveriesByInterval(1, pageSize);
    },
    pageNumberChanged(pageNumber){
      this.getDeliveriesByInterval(pageNumber, this.defaultPageSize);
    },
    searchDeliveries(){
      if(!this.search || this.search.length < 3){
        alert('Type at least 3 characters to search!');
        return;
      }
      var url = this.$apiurl + API_URL +"/search/"+this.search;
      this.$axios.get(url)
        .then(response => {
            this.deliveries = response.data;
            this.recordCount = response.data.length;
        }) 
        .catch(error => {
            console.log(error);
        });
    },
    getDeliveries(pageNumber, pageSize){  
      var url = this.$apiurl + API_URL; 
      url += "/paginated/" + pageSize + "/" + pageNumber;
      this.$axios.get(url)
        .then(response => {
            this.deliveries = response.data.deliveryList;
            this.recordCount = response.data.allDeliveryCount;
        }) 
        .catch(error => {
            console.log(error);
        });                
    },
    getDeliveriesByInterval( pageNumber, pageSize ){
      var url = this.$apiurl + API_URL; 
      
      url += "/paginated/" + pageSize + "/" + pageNumber;
      this.$axios.get(url, { 
          params: {
            startDate: this.deliveriesStartDate,
            endDate: this.deliveriesEndDate
          }                                               
        })
        .then(response => {
            this.deliveries = response.data.deliveryList;
            this.recordCount = response.data.allDeliveryCount;
        }) 
        .catch(error => {
            console.log(error);
        });  
    },
  },
}
</script>
